import styles from "assets/css/Invitaion.module.css";
import Button from "@mui/material/Button";
import {invitationStatus} from "./Invitations";

export const ResponseToInvitation = ({requestStatus}) => {
    return (
        <>
            {requestStatus === invitationStatus.INVITATION_ACCEPTED &&
                <>
                    <p className={styles.statusStyle}>تایید ثبت نام با موفقیت انجام شد.</p>
                    <p className={styles.download}>میتوانید از طریق دکمه زیر اپلیکیشن دستیار را دانلود کنید </p>
                    <Button className={styles.downloadButton}>
                        <a style={{color: 'inherit'}}
                           href={`https://freesens.ir/`}
                           target='_blank'
                           rel='noreferrer'>دانلود اپلیکیشن</a></Button>
                </>
            }
            {requestStatus === invitationStatus.INVITATION_REJECTED &&
                <p className={styles.statusStyle}>انصراف از ثبت نام با موفقیت انجام شد.</p>
            }
        </>
    )
}